// @flow strict
import React from 'react';
import Helmet from 'react-helmet';
import type { Node as ReactNode } from 'react';
import { useSiteMetadata } from '../../hooks';

import Box from "@pagerland/common/src/components/Box";
import Container from "@pagerland/common/src/components/Container";

import SEO from "../SEO";
import preview from "@pagerland/themes/src/RealEstate/assets/backgroundcourses-1.jpg";
import WhatsAppWidget from "../WhatsAppWidget";

import Theme, { theme } from "@pagerland/themes/src/RealEstate";

import {
  Navbar,
  WelcomeEmpty
} from "@pagerland/themes/src/RealEstate/containers";

type Props = {
  children: ReactNode,
  title: string,
  description?: string,
  socialImage?: string
};

const Layout = ({
  children,
  title,
  description,
  socialImage = '',
  WrapperProps,
  ContainerProps,
}: Props) => {
  const { author, url } = useSiteMetadata();
  const metaImage = socialImage || author.photo;
  const metaImageUrl = url + metaImage;

  return (
    <Theme>
      <Helmet>
        <html lang="en" />
        <link href={theme.typography.googleFont} rel="stylesheet" />
        <meta name="theme-color" content={theme.colors.primary} />
        <meta property="og:image" content={`${url}${preview}`} />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:site_name" content={title} />
        <meta property="og:image" content={metaImageUrl} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={metaImageUrl} />
      </Helmet>

      <SEO title={"Montessori and Children Toys "} />
      <Navbar />
      <WhatsAppWidget />
      <WelcomeEmpty name="Blog" homepage="1" />
      <Box name="Blog" {...WrapperProps}>
        <Container {...ContainerProps}>
          {children}
        </Container>
      </Box>
    </Theme>
  );
};

export default Layout;
